import { useContext } from 'react'
import { AppContext } from 'App'

const useApp = () => {
	return useContext(AppContext)
}

export default useApp